import React from "react";
import { Square } from "@/components/Square";
import { useMediaQuery } from "@mui/material";
import { theme } from "@/theme";
import { ScentButton } from "./ScentButton";
import { usePdpFocusedScent } from "@/features/pdp/PdpContext";
import { ScentDetails } from "@/store";

export const FragranceSection = ({ scents }: { scents: ScentDetails[] }) => {
  const isMobile: boolean = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.lg)
  );
  const selectedScent = usePdpFocusedScent();
  const activeScent =
    scents.find((scent) => scent.name === selectedScent?.name) || scents[0];
  return (
    <section className="w-full md:mx-14 md:pt-14 lg:max-w-screen-xl">
      <div
        className="px-5 pb-8 pt-4 md:px-14 lg:rounded-[3px] lg:pb-0 lg:pt-0"
        style={{
          background:
            activeScent?.pdpFragranceSectionContent?.sectionBankgroundColor ??
            "linear-gradient(70deg, #F8F7FF 7.44%, #E6E3FF 90.9%)",
        }}
      >
        <div className="items-center lg:flex lg:space-x-12">
          <div className="flex-shrink-0 lg:basis-[39.8%]">
            {activeScent?.pdpFragranceSectionImage ? (
              isMobile ? (
                <div className="mx-auto max-w-md">
                  <Square>
                    <img
                      src={activeScent?.pdpFragranceSectionImage ?? ""}
                      alt={activeScent?.name}
                      loading="lazy"
                      width={335}
                      height={335}
                    />
                  </Square>
                </div>
              ) : (
                <img
                  src={activeScent?.pdpFragranceSectionImage ?? ""}
                  alt={activeScent?.name}
                  loading="lazy"
                  width={330}
                  className="w-full"
                />
              )
            ) : null}
          </div>
          <div className="grow lg:py-16">
            <div className="mb-10 lg:mb-[4.5rem]">
              <h2 className="mb-0 text-center text-6xl font-normal text-black lg:text-left lg:text-[2.5rem]">
                {activeScent?.pdpFragranceSectionContent?.title}
              </h2>
            </div>
            <div className="flex flex-col items-center space-y-6 md:flex-row md:flex-wrap md:justify-center md:gap-x-[60px] md:gap-y-8 md:space-y-0 lg:justify-between lg:gap-x-2">
              <div
                className="flex h-[54px] max-w-fit items-center justify-center rounded-full px-4 py-1 text-base font-semibold md:order-1 lg:h-[64px]"
                style={{ backgroundColor: activeScent?.color }}
              >
                <span className="font-myriad-pro-condensed text-6xl font-semibold uppercase leading-none md:text-5xl lg:text-[40px]">
                  {activeScent?.name}
                </span>
              </div>
              <div className="flex w-full items-center space-x-6 md:order-3 md:flex-col md:items-center md:space-x-0 md:space-y-2 lg:items-start">
                {activeScent?.pdpFragranceSectionContent?.benefits?.length && (
                  <ul className="flex-shrink-0 basis-[48%] items-center gap-x-6 gap-y-2 space-y-2 md:flex md:flex-wrap md:justify-center md:space-y-0 lg:justify-start">
                    {activeScent?.pdpFragranceSectionContent?.benefits.map(
                      (item, index) => (
                        <li
                          key={item + index}
                          className="flex items-center space-x-2"
                        >
                          <svg
                            width="15"
                            height="17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="flex-shrink-0"
                          >
                            <path
                              d="M0 9.941c0 3.522 3.235 6.377 7.226 6.377s7.226-2.855 7.226-6.377S9.806 2.311 7.226.318C4.646 2.311 0 6.42 0 9.941Z"
                              fill="#000D8C"
                            />
                          </svg>
                          <span className="font-myriad-pro-condensed text-md font-semibold uppercase text-black md:text-xl">
                            {item}
                          </span>
                        </li>
                      )
                    )}
                  </ul>
                )}
                <p className="text-xs md:text-md">
                  {activeScent?.pdpFragranceSectionContent?.belowBenefitCopy}
                </p>
              </div>
              {scents.length > 1 && (
                <div className="flex w-full items-center justify-center space-x-4 px-[18px] md:order-2 md:w-auto md:px-0">
                  <p className="mb-0 text-xs font-semibold">Select scent</p>
                  <div
                    className="flex-shrink-0 rounded-full border border-solid border-primary px-3 py-2"
                    style={{
                      backgroundColor:
                        activeScent?.pdpFragranceSectionContent?.scentChipBg ??
                        "#F3F1FF",
                    }}
                  >
                    <ul className="flex w-full items-center space-x-2">
                      {scents.map((x) => (
                        <li key={x.name}>
                          <ScentButton
                            scent={x}
                            focused={x == activeScent}
                            hoverAction={false}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
